import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardRouter} from './internal/DashboardRouter'
import ManagementsRouter from './internal/ManagementRouter'
import AccessRouter from './internal/AccessRouter'
import TransactionRouter from './internal/TransactionRouter'

export function PrivateRoutes() {
    const ProfilePage = lazy(() => import('../pages/profile'))

    return (
        <Suspense fallback={<FallbackView />}>
            <Switch>
                <Route path='/meu-perfil' component={ProfilePage} />

                <Route path='/painel' component={DashboardRouter} />
                <Route path='/gestao' component={ManagementsRouter} />
                <Route path='/transacoes' component={TransactionRouter} />
                <Route path='/acessos' component={AccessRouter} />

                <Redirect from='/autenticacao' to='/painel/administrativo' />
                <Redirect exact from='/' to='/painel/administrativo' />
                <Redirect to='error/404' />
            </Switch>
        </Suspense>
    )
}
